export const GET_PROGRAM_INNOVATION_SUCCESS = 'GET_PROGRAM_INNOVATION_SUCCESS';
export const GET_PROGRAM_INNOVATION_FAILURE = 'GET_PROGRAM_INNOVATION_FAILURE';

export const POST_PROGRAM_INNOVATION_SUCCESS =
  'POST_PROGRAM_INNOVATION_SUCCESS';
export const POST_PROGRAM_INNOVATION_FAILURE =
  'POST_PROGRAM_INNOVATION_FAILURE';
